module.exports = __webpack_public_path__ + "static/img/chery_1@2x.5767641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_1@2x.png
// module id = CsrJ
// module chunks = 0